import {DateTime} from 'util/time';
import {NewSpaceEvent, SpaceEvent, SpaceEventSpace, SpaceEventType, UpdatedSpaceEvent} from 'services/entities/events';
import {callAPI} from 'services/api';
import {CurrencyAmount} from 'util/currency';
import config from 'config';
import {readCurrency} from 'services/currency';
import {formatQueryString} from 'util/url';

export function getSpaceEventTypeName(type: SpaceEventType) {
  switch(type) {
    case SpaceEventType.Event:
      return 'Event';
    default:
    case SpaceEventType.Retail:
      return 'Retail pop-up store';
  }
}

function readSpaceEvent(data: any): SpaceEvent {
  const { start_time, end_time, hero_image, entry_cost, link, space, ...props } = data;
  const currency = readCurrency(space.currency);
  const eventSpace: SpaceEventSpace = {
    code: space.code,
    name: space.name
  };
  return {
    startTime: DateTime.parse(start_time),
    endTime: DateTime.parse(end_time),
    heroImage: hero_image ? new URL(hero_image, config.api.url) : null,
    entryCost: entry_cost ? CurrencyAmount.parse(entry_cost, currency) : null,
    link: link ? new URL(link) : null,
    space: eventSpace,
    ...props
  }
}

function writeSpaceEvent(event: NewSpaceEvent|UpdatedSpaceEvent, formData: FormData) {
  formData.append('name', event.name);
  formData.append('description', event.description);
  formData.append('type', event.type);
  if(event.heroImage === null) {
    formData.append('hero_image', '');
  } else if(event.heroImage) {
    formData.append('hero_image', event.heroImage);
  }
  formData.append('entry_cost', event.entryCost ? event.entryCost.toString() : '0');
  formData.append('link', event.link?.toString() || '');
}

export async function loadSpaceEvents(max?: number, filters?: {minTime?: DateTime, maxTime?: DateTime, space?: string}): Promise<SpaceEvent[]> {
  const queryParams: any = {};
  if(max) {
    queryParams.limit = max;
  }
  if(filters) {
    if(filters.minTime) {
      queryParams.min_time = filters.minTime.format();
    }
    if(filters.maxTime) {
      queryParams.max_time = filters.maxTime.format();
    }
    if(filters.space) {
      queryParams.space = filters.space;
    }
  }
  const queryString = formatQueryString(queryParams);
  const response = await callAPI(`/spaces/events/?${queryString}`, 'GET');
  if(max) {
    return response.results.map(readSpaceEvent);
  } else {
    return response.map(readSpaceEvent);
  }
}

export async function loadBookingEvent(bookingCode: string): Promise<SpaceEvent> {
  const response = await callAPI(`/bookings/${bookingCode}/event/`, 'GET', null, true);
  return readSpaceEvent(response);
}

export async function createBookingEvent(event: NewSpaceEvent, bookingCode: string): Promise<SpaceEvent> {
  const formData = new FormData();
  writeSpaceEvent(event, formData);
  const response = await callAPI(`/bookings/${bookingCode}/event/`, 'POST', formData, true);
  return readSpaceEvent(response);
}

export async function updateBookingEvent(event: UpdatedSpaceEvent, bookingCode: string): Promise<SpaceEvent> {
  const formData = new FormData();
  writeSpaceEvent(event, formData);
  const response = await callAPI(`/bookings/${bookingCode}/event/`, 'PUT', formData, true);
  return readSpaceEvent(response);
}